import React,{useEffect, useState} from "react";
import { motion,  AnimatePresence  } from "framer-motion";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/bentonite-breadcrumb.webp';
import { useNavigate } from "react-router-dom";
import { bentoniteCommonData } from "../Data";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import collectionPageSchema from "../Schema/CollectionPageSchema";
import itemListSchema from '../Schema/ItemListSchema'

const BentoniteCommon=()=>{
    useEffect(() => {
                document.title =
                  "Bentonite Mineral Products | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Explore Iris Impulse India Pvt. Ltd.'s premium bentonite minerals, including animal feed, drilling, foundry, paper, pencil, pet litter, fertilizer, GCL grades, and more."
                  );
                }
            
              const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/bentonite-minerals");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Bentonite Mineral Products | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India’s Pvt. Ltd. premium bentonite minerals, including animal feed, drilling, foundry, paper, pencil, pet litter, fertilizer, GCL grades, and more."
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/bentonite-minerals");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/bentonite.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Bentonite Mineral Products | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India’s Pvt. ltd. premium bentonite minerals, including animal feed, drilling, foundry, paper, pencil, pet litter, fertilizer, GCL grades, and more."
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/bentonite.webp"
                );
              }
              }, []);

  const [selectedCard, setSelectedCard] = useState(null);
   const navigate = useNavigate();

    const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const cardAnim = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut" }
    }
  };


  const organizationData = organizationSchema();
  const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Bentonite Performance Minerals",
    },
  ],
});
const bentoniteCollectionData = collectionPageSchema({
  url: "https://irisimpulse.com/bentonite-minerals",
  title: "Bentonite Mineral Products | Iris Impulse India Pvt. Ltd.",
  description:
    "Explore Iris Impulse India’s Pvt. ltd. premium bentonite minerals, including animal feed, drilling, foundry, paper, pencil, pet litter, fertilizer, GCL grades, and more.",
  image: "https://irisimpulse.com/Images/bentonite.webp",

  items: [
    {
      name: "Civil Engineering Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/civil-engineering-grade-bentonite",
    },
    {
      name: "Drilling Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/drilling-grade-bentonite",
    },
    {
      name: "IOP Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/iop-grade-bentonite",
    },
    {
      name: "Foundry Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/foundry-grade-bentonite",
    },
    {
      name: "Paper Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/paper-grade-bentonite",
    },
    {
      name: "Animal Feed Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/animal-feed-grade-bentonite",
    },
    {
      name: "GCL Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/gcl-bentonite",
    },
    {
      name: "Pet Litter Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/pet-litter-bentonite",
    },
    {
      name: "Fertilizer Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/fertilizer-grade-bentonite",
    },
    {
      name: "Earthing Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/earthing-grade-bentonite",
    },
    {
      name: "Pencil Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/pencil-grade-bentonite",
    },
  ],
});
const bentoniteItemsData = itemListSchema({
  name: "Bentonite Mineral Products | Iris Impulse India Pvt. Ltd.",
  description:"Explore Iris Impulse India’s Pvt. ltd. premium bentonite minerals, including animal feed, drilling, foundry, paper, pencil, pet litter, fertilizer, GCL grades, and more.",
  url: "https://irisimpulse.com/bentonite-minerals",

  items: [
    {
      name: "Civil Engineering Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/civil-engineering-grade-bentonite",
      image: "https://irisimpulse.com/Images/civil-eng-grade-intro.webp",
    },
    {
      name: "Drilling Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/drilling-grade-bentonite",
      image: "https://irisimpulse.com/Images/drilling-grade-intro.webp",
    },
    {
      name: "IOP Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/iop-grade-bentonite",
      image: "https://irisimpulse.com/Images/iop-grade-intro.webp",
    },
    {
      name: "Foundry Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/foundry-grade-bentonite",
      image: "https://irisimpulse.com/Images/foundry-grade-intro.webp",
    },
    {
      name: "Paper Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/paper-grade-bentonite",
      image: "https://irisimpulse.com/Images/paper-grade-intro.webp",
    },
    {
      name: "Animal Feed Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/animal-feed-grade-bentonite",
      image: "https://irisimpulse.com/Images/animal-feed-grade-intro.webp",
    },
    {
      name: "GCL Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/gcl-bentonite",
      image: "https://irisimpulse.com/Images/gcl-grade-intro.webp",
    },
    {
      name: "Pet Litter Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/pet-litter-bentonite",
      image: "https://irisimpulse.com/Images/pet-litter-intro.webp",
    },
    {
      name: "Fertilizer Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/fertilizer-grade-bentonite",
      image: "https://irisimpulse.com/Images/fertilizer-grade-intro.webp",
    },
    {
      name: "Earthing Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/earthing-grade-bentonite",
      image: "https://irisimpulse.com/Images/earthing-grade-intro.webp",
    },
    {
      name: "Pencil Grade Bentonite",
      url: "https://irisimpulse.com/bentonite-minerals/pencil-grade-bentonite",
      image: "https://irisimpulse.com/Images/pencil-grade-intro.webp",
    },
  ],
});
    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={bentoniteCollectionData} />
      <SchemaMarkup data={bentoniteItemsData} />

          <BreadCrumb
  title="Bentonite Performance Minerals" 
  bgImage={bgImg} 
/>

{/**BENTONITE CARDS SECTION */}
<div className="bg-section bentonite-sec">
 <section className="card-section bentonite-common-page container">
      
      {/* HEADING */}
      <motion.h2
        className="section-heading"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        Our Bentonite Products for Industrial Applications
      </motion.h2>

      {/* CARDS */}
       <motion.div
        className={`cards-grid ${
    bentoniteCommonData.length % 3 === 2 ? "two-cards-grid-bentonite-common" : ""
  }`}
  variants={container}
  initial="hidden"
  animate="visible"
      >
       {bentoniteCommonData.map((card) => (
          <motion.div
            key={card.id}
            className="card"
            variants={cardAnim}
            whileHover={{ y: -8 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setSelectedCard(card)}
          >
            <div className="card-content">
              
              {/* IMAGE */}
              <div className="image-wrapper">
                <motion.img
                  src={card.img}
                  alt={`${card.cardDescription} | Iris Impulse India Pvt. Ltd.`}
                  className="card-image"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.5 }}
                />
              </div>

              <h3>{card.cardTitle}</h3>
              <p>{card.cardDescription}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>

      {/* MODAL */}
      <AnimatePresence>
        {selectedCard && (
          <motion.div
            className="modal-overlay"
            onClick={() => setSelectedCard(null)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
      <motion.div
  className="modal-content"
  onClick={(e) => e.stopPropagation()}
  initial={{ opacity: 0, scale: 0.9, y: 40 }}
  animate={{ opacity: 1, scale: 1, y: 0 }}
  exit={{ opacity: 0, scale: 0.9, y: 40 }}
  transition={{ duration: 0.4, ease: "easeOut" }}
>
  
  {/* CLOSE BUTTON */}
  <div className="modal-header">
  <button className="modal-close"
   onClick={(e) => {
    e.stopPropagation();  
    setSelectedCard(null); 
  }}>×</button>
</div>

  <img src={selectedCard.largeImg} alt={`${selectedCard.cardDescription} | Iris Impulse India Pvt. Ltd.`} />
  <h3>{selectedCard.cardTitle}</h3>
  <h4>{selectedCard.cardDescription}</h4>
  <p className="section-text">{selectedCard.introPara}</p>

  <motion.a
  href={`/bentonite-minerals/${selectedCard.url}`}
    className="outline-btn"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.97 }}
    onClick={() => navigate(`/bentonite-minerals/${selectedCard.url}`)}
  >
    LEARN MORE
  </motion.a>

</motion.div>
          </motion.div>
        )}
      </AnimatePresence>

    </section>
    </div>
    <div style={{marginBottom:"-80px"}}></div>
        </>
    )
}
export default BentoniteCommon;